module.exports = __webpack_public_path__ + "img/SVK.e83a1a0a.svg";